import { API_URL } from "./api";

/**
 * The drive's administration screens read the hub.
 *
 * These pages were written when this application's Next server and its Express backend answered
 * from one origin, so they fetched a relative `/api/admin/...`. Under the suite that URL belongs
 * to nobody — Next has no such route handler, and the pooled drive data (the only thing an
 * administrator's numbers can be about) lives behind `NEXT_PUBLIC_API_URL`, which is also where
 * the sign-in token is valid.
 *
 * The bearer goes out on every call: this UI is served from its own port, and the hub's session
 * cookie does not cross to it by design, so the token the NextAuth callback stored is the only
 * credential that means anything here.
 */
export function useAdminFetch() {
  return async function adminGet<T>(path: string): Promise<T> {
    const token = localStorage.getItem('auth_token');
    const res = await fetch(`${API_URL}/api${path}`, {
      headers: { Authorization: `Bearer ${token ?? ""}` },
      cache: "no-store",
    });
    if (!res.ok) throw new Error(`Admin request failed with ${res.status}`);
    return (await res.json()) as T;
  };
}